module.exports = __webpack_public_path__ + "static/media/more-button.1543c18e.svg";